import React from 'react';
import { Outlet } from 'react-router-dom';
import NavSidebar from './NavSidebar';
import './sidebarstyle.css';

const Layout = () => {
	return (
		<div>
			<NavSidebar/>
			<main className="main-content">
				<Outlet/>
			</main>
		</div>
	);
};

export default Layout;